import { Provider } from '@angular/core';

import { IrpfRepositoryImpl } from '@app/data/repositories/ptrab/irpf/irpf.repository';
import { IRPF_REPOSITORY } from '@app/domain/repositories/ptrab/irpf/irpf.repository.contract';

export const irpfRepositoryProvider: Provider = {
  provide: IRPF_REPOSITORY,
  useClass: IrpfRepositoryImpl
};
